import { render } from "./ExamTestReviewPage.vue?vue&type=template&id=176cb84e&scoped=true"
import script from "./ExamTestReviewPage.vue?vue&type=script&lang=js"
export * from "./ExamTestReviewPage.vue?vue&type=script&lang=js"

import "./ExamTestReviewPage.vue?vue&type=style&index=0&id=176cb84e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176cb84e"]])

export default __exports__